import { useCallback } from 'react';

import { type Board, type Clip } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AirActionTrackingLocation } from '../types';

export type TrackMovedClipsToBoardParams = {
  fromId: Board['id'];
  toId: Board['id'];
  clipIds: Clip['id'][];
  location: AirActionTrackingLocation;
  selectAll?: boolean;
  totalSelectionCount?: number;
};

export const useTrackMovedClipsToBoard = () => {
  const { track } = useAnalyticsUtilities();

  const trackMovedClipsToBoard = useCallback(
    (params: TrackMovedClipsToBoardParams) => {
      track(`Moved clips to a board`, params, { integrations: { Intercom: true } });
    },
    [track],
  );

  return { trackMovedClipsToBoard };
};
